import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const TZ = "Asia/Ho_Chi_Minh";
export const PAGE_LIMIT = 10;

const WEEKDAYS = ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];
const WEEKDAYS_SHORT = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
const FINISHED = new Set([-1, -10, -11, -12, -13, -14]);
const LIVE = new Set([1, 2, 3, 4, 5]);
const LIVE_KEYS = [
  "homeScore",
  "awayScore",
  "homeYellow",
  "homeRed",
  "awayYellow",
  "awayRed",
  "homeCorner",
  "awayCorner",
  "status",
];

export function todayKey() {
  return dayjs().tz(TZ).format("YYYY-MM-DD");
}

export function minDateKey() {
  return dayjs().tz(TZ).startOf("day").subtract(10, "year").format("YYYY-MM-DD");
}

export function maxDateKey() {
  return dayjs().tz(TZ).startOf("day").add(10, "year").format("YYYY-MM-DD");
}

export function formatDateKey(key, pattern = "DD/MM/YYYY") {
  const d = dayjs.tz(key, TZ);
  return d.isValid() ? d.format(pattern) : "";
}

export function buildDateChips(direction = "backward") {
  const today = dayjs().tz(TZ).startOf("day");
  const forward = direction === "forward";
  return Array.from({ length: 7 }, (_, i) => {
    const d = forward ? today.add(i, "day") : today.subtract(i, "day");
    let short;
    let label;
    if (i === 0) {
      short = "Hôm nay";
      label = "Hôm nay";
    } else if (i === 1) {
      short = forward ? "Ngày mai" : "Hôm qua";
      label = forward ? `Ngày mai (${d.format("DD/MM")})` : "Hôm qua";
    } else {
      short = WEEKDAYS_SHORT[d.day()];
      label = `${WEEKDAYS[d.day()]} (${d.format("DD/MM")})`;
    }
    return {
      key: d.format("YYYY-MM-DD"),
      label,
      short,
      dateLabel: d.format("DD/MM"),
    };
  });
}

export function teamLabel(team, fallbackName) {
  return team?.nameVi || team?.name || fallbackName || "";
}

export function listLeagueName(league) {
  return league?.nameVN || league?.name || "";
}

export function modalLeagueName(league) {
  return league?.name || league?.nameVN || "";
}

export function isHotLeague(league) {
  return league?.isHot === true || league?.isHot === 1 || league?.isHot === "1";
}

export function num(value) {
  if (value == null || value === "") return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function phaseOf(status) {
  const s = Number(status);
  if (s === 0) return "upcoming";
  if (LIVE.has(s)) return "live";
  if (FINISHED.has(s)) return "done";
  return "done";
}

export function kickoffParts(matchTime) {
  const d = dayjs.unix(Number(matchTime)).tz(TZ);
  if (!d.isValid()) return { time: "--:--", date: "--/--" };
  return { time: d.format("HH:mm"), date: d.format("DD/MM") };
}

export function mergeLive(match, live) {
  if (!live) return match;
  const next = { ...match };
  LIVE_KEYS.forEach((key) => {
    if (live[key] !== undefined && live[key] !== null) next[key] = live[key];
  });
  if (live.minute !== undefined && live.minute !== null) next.minute = live.minute;
  if (live.currentMinute !== undefined && live.currentMinute !== null) {
    next.currentMinute = live.currentMinute;
  }
  if (live.halfStartTime !== undefined && live.halfStartTime !== null) {
    next.liveHalfStartTime = live.halfStartTime;
  }
  return next;
}

export function liveMinuteLabel(match) {
  const status = Number(match?.status);
  if (match?.minute != null && match.minute !== "") return `${match.minute}'`;
  if (match?.currentMinute != null && match.currentMinute !== "") return `${match.currentMinute}'`;
  if (status === 2) return "HT";
  if (status === 5) return "PEN";

  const start = Number(match?.liveHalfStartTime);
  const now = Math.floor(Date.now() / 1000);
  if (!Number.isFinite(start) || start <= 0) {
    if (status === 1) return "1'";
    if (status === 3) return "46'";
    if (status === 4) return "ET";
    return "LIVE";
  }
  const elapsed = Math.max(0, Math.floor((now - start) / 60));
  if (status === 1) return elapsed >= 45 ? `45+${elapsed - 45}'` : `${elapsed}'`;
  if (status === 3) {
    const minute = 45 + elapsed;
    return minute >= 90 ? `90+${minute - 90}'` : `${minute}'`;
  }
  if (status === 4) return `ET+${elapsed}'`;
  return `${elapsed}'`;
}
